import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSession } from "@/lib/session";
import { AuthShell } from "@/components/AuthShell";
import { api } from "@/lib/api";

export default function RegisterPage() {
  const { register } = useSession();
  const navigate = useNavigate();
  const [orgName, setOrgName] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);
  const [sending, setSending] = useState(false);

  async function sendOtp() {
    setSending(true);
    setError("");
    setInfo("");
    try {
      const data = await api<{ message?: string }>("/auth/request-otp", {
        method: "POST",
        body: JSON.stringify({ mobile, register: true }),
      });
      setInfo(data.message || "OTP sent.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not send OTP");
    } finally {
      setSending(false);
    }
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(orgName, name, mobile, otp);
      navigate("/app/apps");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not create account");
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell>
      <form className="card auth-form" onSubmit={onSubmit}>
        <p className="eyebrow">New business</p>
        <h2>Create an account</h2>
        <p className="muted">
          Creates your <b>app</b> with a unique MQTT Token and Client ID for your in-house Neron
          PBX. Tap Send OTP to receive a live SMS on your mobile.
        </p>
        <label className="field">
          <span>Company / app name</span>
          <input
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            placeholder="e.g. Acme Office"
            required
          />
        </label>
        <label className="field">
          <span>Your name</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your full name"
            required
          />
        </label>
        <label className="field">
          <span>Mobile number</span>
          <input
            inputMode="tel"
            autoComplete="tel"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="10-digit mobile"
            required
          />
        </label>
        <div className="auth-row">
          <span />
          <button
            type="button"
            className="linkish"
            onClick={() => void sendOtp()}
            disabled={sending || !mobile}
          >
            {sending ? "Sending…" : "Send OTP"}
          </button>
        </div>
        <label className="field">
          <span>OTP</span>
          <input
            inputMode="numeric"
            autoComplete="one-time-code"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
            placeholder="6-digit OTP"
            required
          />
        </label>
        {info ? <p className="auth-ok">{info}</p> : null}
        <p className="error">{error}</p>
        <button className="btn btn-block" disabled={busy}>
          {busy ? "Creating app…" : "Create account & app"}
        </button>
        <p className="auth-alt">
          Already have an account? <Link to="/">Sign in</Link>
        </p>
      </form>
    </AuthShell>
  );
}
